import { ContextServiceImpl, onRunForContextService } from "./context-service";
import { ApplicationContextServiceImpl } from "./application-context-service";
import app from "../../sdAppModule";

app
  .service("contextService", ContextServiceImpl)
  .service("applicationContextService", ApplicationContextServiceImpl)
  .run(onRunForContextService);
